import { persistedExchange } from '@urql/exchange-persisted';
import { cacheExchange, Client, createClient, fetchExchange } from '@urql/core';

import { contentfulGraphQLURL } from 'codegen';

const urqlPersistedExchange = persistedExchange({
	preferGetForPersistedQueries: true,
	enforcePersistedQueries: false,
});

const urqlExchanges = [cacheExchange, urqlPersistedExchange, fetchExchange];

const graphQlClient = createClient({
	url: contentfulGraphQLURL,
	exchanges: urqlExchanges,
	requestPolicy: 'network-only',
	fetchOptions: () => {
		return {
			headers: {
				Authorization: `Bearer ${process.env.CONTENTFUL_ACCESS_TOKEN}`,
				'content-type': 'application/json',
			},
		};
	},
});

const previewGraphQlClient = createClient({
	url: contentfulGraphQLURL,
	exchanges: urqlExchanges,
	requestPolicy: 'network-only',
	fetchOptions: () => {
		return {
			headers: {
				Authorization: `Bearer ${process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN}`,
				'content-type': 'application/json',
			},
		};
	},
});

export const client = graphQlClient;
export const previewClient = previewGraphQlClient;

export const asyncClient = async () => {
	const accessToken = process.env.TAG_CONTENTFUL_ACCESS_TOKEN;

	if (!accessToken) {
		return null;
	}
	const graphQlClient = createClient({
		url: contentfulGraphQLURL,
		exchanges: urqlExchanges,
		requestPolicy: 'network-only',
		fetchOptions: () => {
			return {
				headers: {
					Authorization: `Bearer ${accessToken}`,
					'content-type': 'application/json',
				},
			};
		},
	});
	return graphQlClient;
};

export const asyncPreviewClient = async () => {
	const previewAccessToken = process.env.TAG_CONTENTFUL_PREVIEW_ACCESS_TOKEN;
	if (!previewAccessToken) {
		return null;
	}
	const previewGraphQlClient = createClient({
		url: contentfulGraphQLURL,
		exchanges: urqlExchanges,
		requestPolicy: 'network-only',
		fetchOptions: () => {
			return {
				headers: {
					Authorization: `Bearer ${previewAccessToken}`,
					'content-type': 'application/json',
				},
			};
		},
	});

	return previewGraphQlClient;
};

let urqlClient: Client | null = null;
let urqlPreviewClient: Client | null = null;

export const getClient = async (preview: boolean) => {
	if (preview) {
		if (urqlPreviewClient === null) {
			urqlPreviewClient = await asyncPreviewClient();
		}
		return urqlPreviewClient;
	} else {
		if (urqlClient === null) {
			urqlClient = await asyncClient();
		}
		return urqlClient;
	}
};

let beffeGraphQlClient: Client | null = null;

export const getBeffeGraphQlClient = (url: string) => {
	if (beffeGraphQlClient === null) {
		beffeGraphQlClient = createClient({
			url,
			exchanges: [cacheExchange, fetchExchange],
			requestPolicy: 'network-only',
			fetchOptions: () => {
				return {
					headers: {
						'content-type': 'application/json',
					},
				};
			},
		});
	}
	return beffeGraphQlClient;
};
